// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/code/index.scss
// module id = 248
// module chunks = 0